// extracted by mini-css-extract-plugin
export default {"containerListTable":"AssignListTable_containerListTable__YO0n2"};